<template>
  <VLayout>
    <VFlex xs8>
      <VCard style="height: calc(100vh - 100px)">
        <VLayout justify-space-around row>
          <VFlex xs6>
            <VCardTitle style="font-variant: small-caps">
              <h1>Valute</h1>
              <v-spacer />
            </VCardTitle>
            <VContainer class="pa-0" fill-height fluid>
              <VLayout fill-height>
                <VFlex xs12>
                  <VDataTable
                    :headers="headers"
                    :items="currencies"
                    rows-per-page-text="Vrstic na stran"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs">
                        {{ props.item['iso_code'] }}
                      </td>
                      <td class="text-xs-center">
                        <VTooltip top>
                          <VBtn
                            slot="activator"
                            flat
                            icon
                            color="red"
                            class="ma-auto"
                            @click.stop="deleteCurrency(props.item)"
                          >
                            <VIcon>delete</VIcon>
                          </VBtn>
                          <span>Izbriši valuto</span>
                        </VTooltip>
                      </td>
                    </template>
                    <template slot="no-data"> Sorry, nothing to display here :( </template>
                  </VDataTable>
                </VFlex>
              </VLayout>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
    <VFlex xs4>
      <VCard style="height: calc(100vh - 100px); overflow-y: scroll">
        <VLayout justify-space-around row>
          <VFlex xs10>
            <VCardTitle style="padding: 10px 0 0 0; font-variant: small-caps; margin-bottom: 10px">
              <h2>Dodaj valuto</h2>
            </VCardTitle>
            <VContainer fluid style="padding: 0 0 0 10px">
              <VLayout fill-height row wrap>
                <VFlex xs12>
                  <v-autocomplete
                    v-model="currency"
                    :loading="!allCurrencies"
                    :items="allCurrencies"
                    :filter="filterAllCurrencies"
                    no-data-text="Ni zadetkov"
                    item-text="iso_code"
                    cache-items
                    clearable
                    label="Išči po imenu ali 3 mestni kodi"
                    flat
                  >
                    <template v-slot:item="data">
                      {{ data.item.iso_code }}<small class="px-3">{{ data.item.name }}</small>
                    </template>
                  </v-autocomplete>
                </VFlex>
                <v-flex xs12 style="display: flex; justify-content: flex-end">
                  <VBtn
                    color="primary"
                    :disabled="!currency || currency.length !== 3"
                    @click="createNewCurrency"
                  >
                    Potrdi
                  </VBtn>
                </v-flex>
              </VLayout>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Currencies',
  data() {
    return {
      headers: [
        {
          text: 'Valuta',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Akcije',
          align: 'middle',
          sortable: false,
        },
      ],
      currency: '',
    };
  },
  computed: {
    ...mapGetters({
      currencies: 'currencies',
      allCurrencies: 'allCurrencies',
    }),
  },
  mounted() {
    this.getCurrenciesAction();
    this.getAllCurrenciesAction();
  },
  methods: {
    ...mapActions([
      'setSnackBarStateAction',
      'getCurrenciesAction',
      'getAllCurrenciesAction',
      'createCurrencyAction',
      'removeCurrencyAction',
    ]),
    showSnackbar(successful, msg) {
      const snackbarColor = successful ? 'green' : 'red';
      this.setSnackBarStateAction({
        snackBar: true,
        color: snackbarColor,
        text: msg,
      });
    },
    filterAllCurrencies(currency, queryText, itemText) {
      return (
        currency.name.toLowerCase().includes(queryText.toLowerCase()) ||
        currency.iso_code.toLowerCase().includes(queryText.toLowerCase())
      );
    },
    // ================================ CRUD operations ================================
    async createNewCurrency() {
      try {
        await this.createCurrencyAction({ iso_code: this.currency });
        this.showSnackbar(true, 'Dodajanje valute je bilo uspešno.');
        this.currency = '';
      } catch (err) {
        this.showSnackbar(
          false,
          `Napaka pri dodajanju valute\n. Poskusite znova ali pokličite administratorja.`
        );
      }
    },
    async deleteCurrency(currency) {
      try {
        await this.removeCurrencyAction(currency);
        this.showSnackbar(true, `Valuta ${currency.iso_code} uspešno izbrisana.`);
      } catch (err) {
        this.showSnackbar(
          false,
          'Napaka pri brisanju valute. Poskusite znova ali pokličite administratorja.'
        );
      }
    },
    // ================================/ CRUD operations ================================
  },
};
</script>

<style scoped>
::v-deep .v-table__overflow {
  overflow: auto;
  max-height: 70vh;
}
</style>
